// import { useState, useEffect, useCallback, useRef, useContext } from "react";
// // import '../../../../../assets/css/App.css';
// import StarfieldCanvas from "./StartFeildCanvas";
// import TopBar from "./TopBar";
// import QuestionCard, { Question, QuestionOption } from "./QuestionCard";
// import CompletionScreen from "./CompletionScreen";
// import WipeTransition from "./WipeTransition";
// import { useAudio } from "./UseAudio";
// import questionsData from "./questions.json";
// import "./Assesment.css";
// import CompletionVideo from '../../../../../assets/img/screens/Completion.mp4'
// import { ScoreContext } from "../../GamePreview";

// interface WrongAnswer {
//   questionIndex: number;
//   scenario: string;
//   userChoice: string;
//   correctAnswer: string;
//   feedback: string;
//   skill: string;
// }

// type GamePhase = "playing" | "transition" | "complete";

// interface AssessmentMetrics {
//   originalScore: number;
//   finalScore: number;
//   passAttempts: number;
//   reattempts: number;
//   attemptNumber: number;
// }

// function loadMetrics(): AssessmentMetrics {
//   try {
//     const raw = localStorage.getItem("assessmentMetrics");
//     if (raw) return JSON.parse(raw);
//   } catch {}
//   return { originalScore: -1, finalScore: -1, passAttempts: 0, reattempts: 0, attemptNumber: 0 };
// }

// function saveMetrics(m: AssessmentMetrics) {
//   localStorage.setItem("assessmentMetrics", JSON.stringify(m));
//   window.dispatchEvent(new CustomEvent("assessmentMetrics", { detail: m }));
// }

// export default function AssessmentFutureTheme({ learnerPlayList,setLearnerPlayingDetails,onAssessmentComplete, setCurrentScreenId,reportFetchData}: any) {
//   const [questions, setQuestions] = useState<Question[]>([]);
//   const [passPercentage, setPassPercentage] = useState(80);
//   const [assessmentTitle, setAssessmentTitle] = useState<string | undefined>();
//   const [assessmentSubtitle, setAssessmentSubtitle] = useState<string | undefined>();
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [score, setScore] = useState(0);
//   const [submitted, setSubmitted] = useState(false);
//   const [wrongAnswers, setWrongAnswers] = useState<WrongAnswer[]>([]);
//   const [gamePhase, setGamePhase] = useState<GamePhase>("playing");
//   const { unlockAudio, playTone } = useAudio();
// const [showCompletionVideo, setShowCompletionVideo] = useState(false);
// const [milestoneQuest, setMilestoneQuest] = useState<string | null>(null);
// const {setlearnerActivityrec,deviceInfo } = useContext(ScoreContext);
// const [attemptNumber,setAttemptNumber] = useState(1);
// //new
//   useEffect(() => {
//   const data: any = questionsData;

//   if (data.questions) {
//     setQuestions(data.questions);

//     if (data.passPercentage != null) {
//       setPassPercentage(data.passPercentage);
//     }

//     if (data.assessmentTitle) {
//       setAssessmentTitle(data.assessmentTitle);
//     }

//     if (data.assessmentSubtitle) {
//       setAssessmentSubtitle(data.assessmentSubtitle);
//     }
//   } else {
//     setQuestions(data);
//   }
// }, []);


// useEffect(() => {
//   if (!showCompletionVideo) return;

//   const timer = setTimeout(() => {
//     console.log("Video exceeded 15 seconds. Skipping...");

//     setShowCompletionVideo(false);
//     setMilestoneQuest("1");
//   }, 15000);

//   return () => clearTimeout(timer);
// }, [showCompletionVideo]);
// const metricsRef = useRef<AssessmentMetrics>(
//   learnerPlayList?.Assessment?.length > 0
//     ? learnerPlayList.Assessment[0]
//     : {
//         originalScore: -1,
//         finalScore: -1,
//         passAttempts: 0,
//         reattempts: 0,
//         attemptNumber: 0
//       }
// );


// const handleComplete = useCallback(
//   (finalScorePercent: number, passPct: number) => {
//     const m = { ...metricsRef.current };

//     m.attemptNumber += 1;

//     if (m.originalScore === -1) {
//       m.originalScore = finalScorePercent;
//     }

//     m.finalScore = Math.max(m.finalScore, finalScorePercent);

//     const passed = finalScorePercent >= passPct;
//     const alreadyPassed = (m as any)._firstPassAttempt > 0;

//     if (passed && !alreadyPassed) {
//       (m as any)._firstPassAttempt = m.attemptNumber;
//       m.passAttempts = m.attemptNumber;
//     } else if (alreadyPassed) {
//       m.reattempts += 1;
//     } else {
//       m.passAttempts = m.attemptNumber;
//     }

//     (m as any).passed =
//       passed || (m as any).passed === "Yes" ? "Yes" : "No";

//     metricsRef.current = m;

//     //  IMPORTANT PART — UPDATE STATE
//     setLearnerPlayingDetails((prev: any) => {
//       return {
//         ...prev,
//         Assessment: [m]  
//       };
//     });

//     if (onAssessmentComplete) {
//       onAssessmentComplete(m);
//     }
//   },
//   [setLearnerPlayingDetails, onAssessmentComplete]
// );


//   const handleChoose = useCallback(
//     (opt: QuestionOption) => {
//       if (submitted || questions.length === 0) return;
//       unlockAudio();
//       setSubmitted(true);

//       playTone("tap");

//       const isCorrect = !!opt.correct;
//         const q:any = questions[currentIndex];
//       const correctOpt = q.options.find((o:any) => o.correct);
//             // Update score immediately
//       let updatedScore = score;

//       if(isCorrect){
//         updatedScore = score + 1;
//       }
//        setlearnerActivityrec((prev:any)=>{

//       const screenDetails = [
//         ...(prev?.screendetails || [])
//       ];


//       const screenIndex = screenDetails.findIndex(
//         (screen:any)=>
//           screen.screenId === 17 &&
//           screen.exitTime === null
//       );


//       if(screenIndex === -1){
//         return prev;
//       }


//       const currentAttempt =
//         screenDetails[screenIndex]
//           ?.assessmentAttempts?.[`attempt${attemptNumber}`] || 
//           {
//             score:0,
//             answers:[]
//           };


//       screenDetails[screenIndex] = {

//         ...screenDetails[screenIndex],

//         assessmentAttempts:{

//           ...(screenDetails[screenIndex].assessmentAttempts || {}),


//           [`attempt${attemptNumber}`]:{

//             score:updatedScore,


//             answers:[

//               ...currentAttempt.answers,


//               {
//                 questionId:q.number,

//                 skill:q.skill,

//                 selectedOption:opt.label,

//                 selectedAnswer:opt.text,

//                 correctOption:correctOpt?.label,

//                 correctAnswer:correctOpt?.text,

//                 isCorrect,
// ...deviceInfo,
//                 submittedAt:new Date().toISOString()

//               }

//             ]

//           }

//         }

//       };


//       return {
//         ...prev,
//         screendetails:screenDetails
//       };

//     });
//       if (isCorrect) {
//         setScore((s) => s + 1);
//       } else {
//         // const q = questions[currentIndex];
//         // const correctOpt = q.options.find((o) => o.correct);
//         setWrongAnswers((prev) => [
//           ...prev,
//           {
//             questionIndex: currentIndex,
//             scenario: q.riven + (q.prompt ? "\n" + q.prompt : ""),
//             userChoice: opt.text,
//             correctAnswer: correctOpt?.text || "",
//             feedback: opt.feedback,
//             skill: q.skill,
//           },
//         ]);
//       }

//       setTimeout(() => {
//         if (currentIndex >= questions.length - 1) {
//           // Calculate final score and record metrics
//           const finalCorrect = isCorrect ? score + 1 : score;
//           const pct = Math.round((finalCorrect / questions.length) * 100);
//           handleComplete(pct, passPercentage);
//           setGamePhase("complete");
//         } else {
//           setGamePhase("transition");
//           playTone("whoosh");
//           setTimeout(() => {
//             setCurrentIndex((i) => i + 1);
//             setSubmitted(false);
//             setGamePhase("playing");
//           }, 520);
//         }
//       }, 400);
//     },
//     [submitted, questions, currentIndex, unlockAudio, playTone, score, handleComplete, passPercentage]
//   );

//   const handleRetry = useCallback(() => {
//     setAttemptNumber((prev)=>prev + 1);
//     setCurrentIndex(0);
//     setScore(0);
//     setSubmitted(false);
//     setWrongAnswers([]);
//     setGamePhase("playing");
//   }, []);

//   //new 
//   const hasPreviouslyPassed =
//   learnerPlayList.Assessment?.some((a:any) => a.passed === "Yes") ?? false;

//         if (showCompletionVideo) {
//           return (
//             <div
//               id="fullscreen-video-wrapper"
//               style={{
//                 position: "fixed",
//                 top: 0,
//                 left: 0,
//                 width: "100vw",
//                 height: "100vh",
//                 backgroundColor: "black",
//                 zIndex: 999999,
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <video
//                 src={CompletionVideo}
//                 autoPlay
//                 playsInline
//                 muted={false}
//                 controls={false}
//                 style={{
//                   width: "100vw",
//                   height: "100vh",
//                   objectFit: "cover",
//                 }}
//                 onEnded={() => {
//                   setShowCompletionVideo(false);
//                   setMilestoneQuest("1");
//                 }}
//               />
//             </div>
//           );
//         }
//   if (questions.length === 0) {
//     return (
//       <div className="assess-page">

//         <StarfieldCanvas />
//         <div className="assess-scanlines" />
//         <div className="assess-wrap">
//           <div className="assess-card">
//             <div className="assess-content" style={{ padding: 40, textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flex: 1 }}>
//               <div className="assess-bar" style={{ width: 120, marginBottom: 16 }}><i /></div>
//               <p style={{ fontSize: 13, color: "var(--assess-muted)", margin: 0 }}>Preparing your assessment…</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="assess-page" onClick={unlockAudio}>
//       <StarfieldCanvas />
//       <div className="assess-scanlines" />
//       <div className="assess-wrap">
//         <div className={`assess-card${gamePhase === "complete" ? " assess-completion-card" : ""}`}>
//           {gamePhase === "transition" && <WipeTransition />}

//           {gamePhase === "complete" ? (
//             <CompletionScreen
//               totalQuestions={questions.length}
//               correctCount={score}
//               wrongAnswers={wrongAnswers}
//               onRetry={handleRetry}
//               playTone={playTone}
//               passPercentage={passPercentage}
//                hasPreviouslyPassed={hasPreviouslyPassed}
//                 setCurrentScreenId={setCurrentScreenId} 
//                 reportFetchData={reportFetchData}
//                 setShowCompletionVideo={setShowCompletionVideo}
//                 showCompletionVideo={showCompletionVideo}
//                 setMilestoneQuest={setMilestoneQuest}
//                 milestoneQuest={milestoneQuest}
//             />
//           ) : (
//             <>
//               <TopBar currentIndex={currentIndex} totalQuestions={questions.length} passPercentage={passPercentage} title={assessmentTitle} subtitle={assessmentSubtitle} />
//               <QuestionCard
//                 key={currentIndex}
//                 question={questions[currentIndex]}
//                 submitted={submitted}
//                 onChoose={handleChoose}
//                 playTone={playTone}
//               />
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }




import { useState, useEffect, useCallback, useRef, useContext } from "react";
// import '../../../../../assets/css/App.css';
import StarfieldCanvas from "./StartFeildCanvas";
import TopBar from "./TopBar";
import QuestionCard, { Question, QuestionOption } from "./QuestionCard";
import CompletionScreen from "./CompletionScreen";
import WipeTransition from "./WipeTransition";
import { useAudio } from "./UseAudio";
import questionsData from "./questions.json";
import "./Assesment.css";
import CompletionVideo from '../../../../../assets/img/screens/Completion.mp4'
import { ScoreContext } from "../../GamePreview";
// ##############################
// Completion Video Cache
// ##############################

declare global {
  interface Window {
    _videoBlobCache?: Map<string, string>;
  }
}

if (!window._videoBlobCache) {
  window._videoBlobCache = new Map();
}

interface WrongAnswer {
  questionIndex: number;
  scenario: string;
  userChoice: string;
  correctAnswer: string;
  feedback: string;
  skill: string;
}

type GamePhase = "playing" | "transition" | "complete";

interface AssessmentMetrics {
  originalScore: number;
  finalScore: number;
  passAttempts: number;
  reattempts: number;
  attemptNumber: number;
}

function loadMetrics(): AssessmentMetrics {
  try {
    const raw = localStorage.getItem("assessmentMetrics");
    if (raw) return JSON.parse(raw);
  } catch {}
  return { originalScore: -1, finalScore: -1, passAttempts: 0, reattempts: 0, attemptNumber: 0 };
}

function saveMetrics(m: AssessmentMetrics) {
  localStorage.setItem("assessmentMetrics", JSON.stringify(m));
  window.dispatchEvent(new CustomEvent("assessmentMetrics", { detail: m }));
}

export default function AssessmentFutureTheme({ learnerPlayList,setLearnerPlayingDetails,onAssessmentComplete, setCurrentScreenId,reportFetchData}: any) {
  const [questions, setQuestions] = useState<Question[]>([]);
  const [passPercentage, setPassPercentage] = useState(80);
  const [assessmentTitle, setAssessmentTitle] = useState<string | undefined>();
  const [assessmentSubtitle, setAssessmentSubtitle] = useState<string | undefined>();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [wrongAnswers, setWrongAnswers] = useState<WrongAnswer[]>([]);
  const [gamePhase, setGamePhase] = useState<GamePhase>("playing");
  const { unlockAudio, playTone } = useAudio();
const [showCompletionVideo, setShowCompletionVideo] = useState(false);
const [milestoneQuest, setMilestoneQuest] = useState<string | null>(null);
const {setlearnerActivityrec,deviceInfo } = useContext(ScoreContext);
const [attemptNumber,setAttemptNumber] = useState(1);
// ##############################
// Completion Video Blob
// ##############################

const [completionBlobUrl, setCompletionBlobUrl] = useState(() => {
  const videoSrc = CompletionVideo;

  if (
    window._videoBlobCache &&
    window._videoBlobCache.has(videoSrc)
  ) {
    return window._videoBlobCache.get(videoSrc)!;
  }

  return "";
});


const completionFetchingRef = useRef(false);

useEffect(() => {
  const videoSrc = CompletionVideo;

  // Already cached
  if (
    window._videoBlobCache &&
    window._videoBlobCache.has(videoSrc)
  ) {
    setCompletionBlobUrl(window._videoBlobCache.get(videoSrc)!);
    return;
  }

  if (completionFetchingRef.current) return;

  completionFetchingRef.current = true;

  fetch(videoSrc)
    .then((res) => res.blob())
    .then((blob) => {
      const blobUrl = URL.createObjectURL(blob);

      if (!window._videoBlobCache) {
        window._videoBlobCache = new Map();
      }

      window._videoBlobCache.set(videoSrc, blobUrl);

      setCompletionBlobUrl(blobUrl);

      completionFetchingRef.current = false;
    })
    .catch(() => {
      setCompletionBlobUrl(videoSrc);
      completionFetchingRef.current = false;
    });
}, []);
//new
  useEffect(() => {
  const data: any = questionsData;

  if (data.questions) {
    setQuestions(data.questions);

    if (data.passPercentage != null) {
      setPassPercentage(data.passPercentage);
    }

    if (data.assessmentTitle) {
      setAssessmentTitle(data.assessmentTitle);
    }

    if (data.assessmentSubtitle) {
      setAssessmentSubtitle(data.assessmentSubtitle);
    }
  } else {
    setQuestions(data);
  }
}, []);


useEffect(() => {
  if (!showCompletionVideo) return;

  const timer = setTimeout(() => {
   

    setShowCompletionVideo(false);
    setMilestoneQuest("1");
  }, 15000);

  return () => clearTimeout(timer);
}, [showCompletionVideo]);
const metricsRef = useRef<AssessmentMetrics>(
  learnerPlayList?.Assessment?.length > 0
    ? learnerPlayList.Assessment[0]
    : {
        originalScore: -1,
        finalScore: -1,
        passAttempts: 0,
        reattempts: 0,
        attemptNumber: 0
      }
);


const handleComplete = useCallback(
  (finalScorePercent: number, passPct: number) => {
    const m = { ...metricsRef.current };

    m.attemptNumber += 1;

    if (m.originalScore === -1) {
      m.originalScore = finalScorePercent;
    }

    m.finalScore = Math.max(m.finalScore, finalScorePercent);

    const passed = finalScorePercent >= passPct;
    const alreadyPassed = (m as any)._firstPassAttempt > 0;

    if (passed && !alreadyPassed) {
      (m as any)._firstPassAttempt = m.attemptNumber;
      m.passAttempts = m.attemptNumber;
    } else if (alreadyPassed) {
      m.reattempts += 1;
    } else {
      m.passAttempts = m.attemptNumber;
    }

    (m as any).passed =
      passed || (m as any).passed === "Yes" ? "Yes" : "No";

    metricsRef.current = m;

    //  IMPORTANT PART — UPDATE STATE
    setLearnerPlayingDetails((prev: any) => {
      return {
        ...prev,
        Assessment: [m]  
      };
    });

    if (onAssessmentComplete) {
      onAssessmentComplete(m);
    }
  },
  [setLearnerPlayingDetails, onAssessmentComplete]
);


  const handleChoose = useCallback(
    (opt: QuestionOption) => {
      if (submitted || questions.length === 0) return;
      unlockAudio();
      setSubmitted(true);

      playTone("tap");

      const isCorrect = !!opt.correct;
        const q:any = questions[currentIndex];
      const correctOpt = q.options.find((o:any) => o.correct);
            // Update score immediately
      let updatedScore = score;

      if(isCorrect){
        updatedScore = score + 1;
      }
       setlearnerActivityrec((prev:any)=>{

      const screenDetails = [
        ...(prev?.screendetails || [])
      ];


      const screenIndex = screenDetails.findIndex(
        (screen:any)=>
          screen.screenId === 17 &&
          screen.exitTime === null
      );


      if(screenIndex === -1){
        return prev;
      }


      const currentAttempt =
        screenDetails[screenIndex]
          ?.assessmentAttempts?.[`attempt${attemptNumber}`] || 
          {
            score:0,
            answers:[]
          };


      screenDetails[screenIndex] = {

        ...screenDetails[screenIndex],

        assessmentAttempts:{

          ...(screenDetails[screenIndex].assessmentAttempts || {}),


          [`attempt${attemptNumber}`]:{

            score:updatedScore,


            answers:[

              ...currentAttempt.answers,


              {
                questionId:q.number,

                skill:q.skill,

                selectedOption:opt.label,

                selectedAnswer:opt.text,

                correctOption:correctOpt?.label,

                correctAnswer:correctOpt?.text,

                isCorrect,
...deviceInfo,
                submittedAt:new Date().toISOString()

              }

            ]

          }

        }

      };


      return {
        ...prev,
        screendetails:screenDetails
      };

    });
      if (isCorrect) {
        setScore((s) => s + 1);
      } else {
        // const q = questions[currentIndex];
        // const correctOpt = q.options.find((o) => o.correct);
        setWrongAnswers((prev) => [
          ...prev,
          {
            questionIndex: currentIndex,
            scenario: q.riven + (q.prompt ? "\n" + q.prompt : ""),
            userChoice: opt.text,
            correctAnswer: correctOpt?.text || "",
            feedback: opt.feedback,
            skill: q.skill,
          },
        ]);
      }

      setTimeout(() => {
        if (currentIndex >= questions.length - 1) {
          // Calculate final score and record metrics
          const finalCorrect = isCorrect ? score + 1 : score;
          const pct = Math.round((finalCorrect / questions.length) * 100);
          handleComplete(pct, passPercentage);
          setGamePhase("complete");
        } else {
          setGamePhase("transition");
          playTone("whoosh");
          setTimeout(() => {
            setCurrentIndex((i) => i + 1);
            setSubmitted(false);
            setGamePhase("playing");
          }, 520);
        }
      }, 400);
    },
    [submitted, questions, currentIndex, unlockAudio, playTone, score, handleComplete, passPercentage]
  );

  const handleRetry = useCallback(() => {
    setAttemptNumber((prev)=>prev + 1);
    setCurrentIndex(0);
    setScore(0);
    setSubmitted(false);
    setWrongAnswers([]);
    setGamePhase("playing");
  }, []);

  //new 
  const hasPreviouslyPassed =
  learnerPlayList.Assessment?.some((a:any) => a.passed === "Yes") ?? false;

const rawSrc = CompletionVideo;

const cachedBlob =
  window._videoBlobCache?.get(rawSrc);

const finalSrc =
  cachedBlob ||
  completionBlobUrl ||
  rawSrc;

        if (showCompletionVideo) {
          return (
            <div
              id="fullscreen-video-wrapper"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "black",
                zIndex: 999999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <video
        src={finalSrc}
                autoPlay
                playsInline
                muted={false}
                controls={false}
        preload="auto"
                style={{
                  width: "100vw",
                  height: "100vh",
                  objectFit: "cover",
                }}
                onEnded={() => {
                  setShowCompletionVideo(false);
                  setMilestoneQuest("1");
                }}
              />
            </div>
          );
        }
  if (questions.length === 0) {
    return (
      <div className="assess-page">

        <StarfieldCanvas />
        <div className="assess-scanlines" />
        <div className="assess-wrap">
          <div className="assess-card">
            <div className="assess-content" style={{ padding: 40, textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flex: 1 }}>
              <div className="assess-bar" style={{ width: 120, marginBottom: 16 }}><i /></div>
              <p style={{ fontSize: 13, color: "var(--assess-muted)", margin: 0 }}>Preparing your assessment…</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="assess-page" onClick={unlockAudio}>
      <StarfieldCanvas />
      <div className="assess-scanlines" />
      <div className="assess-wrap">
        <div className={`assess-card${gamePhase === "complete" ? " assess-completion-card" : ""}`}>
          {gamePhase === "transition" && <WipeTransition />}

          {gamePhase === "complete" ? (
            <CompletionScreen
              totalQuestions={questions.length}
              correctCount={score}
              wrongAnswers={wrongAnswers}
              onRetry={handleRetry}
              playTone={playTone}
              passPercentage={passPercentage}
               hasPreviouslyPassed={hasPreviouslyPassed}
                setCurrentScreenId={setCurrentScreenId} 
                reportFetchData={reportFetchData}
                setShowCompletionVideo={setShowCompletionVideo}
                showCompletionVideo={showCompletionVideo}
                setMilestoneQuest={setMilestoneQuest}
                milestoneQuest={milestoneQuest}
            />
          ) : (
            <>
              <TopBar currentIndex={currentIndex} totalQuestions={questions.length} passPercentage={passPercentage} title={assessmentTitle} subtitle={assessmentSubtitle} />
              <QuestionCard
                key={currentIndex}
                question={questions[currentIndex]}
                submitted={submitted}
                onChoose={handleChoose}
                playTone={playTone}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
